<template>
  <block class="product-detail-recommend-reviews"
         title="课程评价"
         :more="showMore"
         more-desc="查看全部"
         @click-more="handleShowMore"
  >
    <div class="product-detail-recommend-reviews-list">
      <template v-if="reviewType === 'review'">
        <review-item v-for="item in list"
                     :key="item.id"
                     :user="item.user"
                     :rate="item.rating"
                     :content="item.content"
                     limit-content-line
        />
      </template>
      <template v-else>
        <comment-item v-for="(item, index) in list"
                      :key="index"
                      :item="item"
                      :show-come-from="true"
                      :show-reply="false"
                      limit-content-line
        />
      </template>
    </div>
  </block>
</template>

<script>
  import Block from '@/components/Block';
  import ReviewItem from '@/pages/Review/components/ReviewItem';
  import CommentItem from '@/components/CommentList/Item';

  export default {
    name: 'ProductDetailRecommendReviews',
    components: {
      Block,
      ReviewItem,
      CommentItem,
    },
    props: {
      reviewType: {
        type: String,
        validator(val) {
          return [
            'comment',
            'review',
          ].includes(val);
        },
        default: 'review',
      },
      list: {
        type: Array,
        required: true,
      },
      showMore: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      handleShowMore() {
        this.$emit('click-more');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-recommend-reviews {
    border-bottom: @size-extra-small solid @background-color-base;

    &-list {
      padding: 0 @size-base;
    }
  }

</style>
